import React from "react";
import Heading from "../components/Heading";
import "../scss/skills.scss";
import Skill from "../components/Skill";
import frontendSkills from "../assets/skills/frontendSkills.json";
import backendSkills from "../assets/skills/backendSkills.json";
import otherSkills from "../assets/skills/otherSkills.json";

const Skills = () => {
  return (
    <section className="skills_container">
      <Heading id="skillsHeading" number="02" text="Skills" />
      <div className="skills">
        <Skill
          id="frontendSkills"
          skillIcon="frontend.svg"
          skillHeading="Frontend"
          skillsList={frontendSkills}
        />
        <Skill
          id="backendSkills"
          skillIcon="backend.svg"
          skillHeading="Backend"
          skillsList={backendSkills}
        />
        <Skill
          id="otherSkills"
          skillIcon="otherSkills.svg"
          skillHeading="Others"
          skillsList={otherSkills}
        />
      </div>
    </section>
  );
};

export default Skills;
